import React, { useState } from 'react';
import {
  List,
  ListItem,
  Title,
  TitleLeft,
  IconBadge,
  TitleText,
  Subtitle,
  EmptyState,
  EmptyIconRing,
} from './styles.pedidosLista';
import Card from '../../components/Card';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { imprimirPedido } from './utils';
import { ButtonConclude, ColumnContainer } from './styles';
import { BackgroundColorMap, StatusIconMap, StatusDescriptionMap } from './constants';
import ConcluirTodos from './ConcluirTodos';
import { useConfig } from '../../hooks/config';
import { FaInbox } from 'react-icons/fa';

export default function PedidosLista({
  data,
  valor,
  status,
  onAbrirDados,
  refresh,
}) {
  const { config } = useConfig();
  const { theme } = useCustomTheme();
  const [modalConclude, setModalConclude] = useState(false);
  const StatusIcon = StatusIconMap[status];

  return (
    <>
      <ColumnContainer>
        <Title style={{ backgroundColor: BackgroundColorMap[status] }}>
          <TitleLeft>
            {StatusIcon && (
              <IconBadge>
                <StatusIcon size={16} />
              </IconBadge>
            )}
            <TitleText>
              <h5 style={{ color: theme.colors.white }}>
                <span>{data?.length || 0}</span> {status} {!config.DisableOrdersTotal ? ` - ${valor}` : ''}
              </h5>
              {StatusDescriptionMap[status] && (
                <Subtitle>{StatusDescriptionMap[status]}</Subtitle>
              )}
            </TitleText>
          </TitleLeft>
          {!config?.DisableOrdersActions && data?.length > 0 && (
            <ButtonConclude onClick={() => setModalConclude(true)}>
              Concluir Todos
            </ButtonConclude>
          )}
        </Title>
        <List>
          {data?.length > 0 ? (
            data.map((pedido) => (
              <ListItem key={pedido.Id}>
                <Card
                  idPedido={pedido.Id}
                  data={pedido}
                  atualizar={refresh}
                  type={
                    ['ANDAMENTO', 'ENTREGA', 'AGENDAMENTO']
                      .includes(status)
                      ? status.toLowerCase()
                      : null
                  }
                  onclick={() => onAbrirDados(pedido)}
                  imprimir={() => imprimirPedido(pedido)}
                />
              </ListItem>
            ))
          ) : (
            <EmptyState>
              <EmptyIconRing>
                <FaInbox size={22} />
              </EmptyIconRing>
              <span>Nenhum pedido</span>
            </EmptyState>
          )}
        </List>
      </ColumnContainer>
      {modalConclude && (
        <ConcluirTodos
          open={modalConclude}
          close={() => setModalConclude(false)}
          status={status}
          pedidos={data}
        />
      )}
    </>
  );
}
